import { render, staticRenderFns } from "./xxzySwiper.vue?vue&type=template&id=39840166&scoped=true&"
import script from "./xxzySwiper.vue?vue&type=script&lang=js&"
export * from "./xxzySwiper.vue?vue&type=script&lang=js&"
import style0 from "./xxzySwiper.vue?vue&type=style&index=0&id=39840166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39840166",
  null
  
)

export default component.exports